import { classJoin } from "@ps/utils";

// eslint-disable-next-line import/prefer-default-export
export const focusVisibleStyles = classJoin.template`
focus:outline-none focus-visible:ring-2
focus-visible:ring-secondary-50
`;
